import { render, staticRenderFns } from "./PatientOrthoDiagnose.vue?vue&type=template&id=5131a662&"
import script from "./PatientOrthoDiagnose.vue?vue&type=script&lang=js&"
export * from "./PatientOrthoDiagnose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports